import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  margin: auto;
`;

export const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;
  border-radius: var(--border-radius-default);
  background: var(--color-surface-default);
  padding: var(--unit-8) var(--unit-6);
`;
